<template>
  <div class="grafico-dona">    
    <apexchart
      type="donut"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    // textTitle: String,
    // textValue: String,
  },
  data() {
    const self = this
    return {
      // series: [10,20],
      // chartOptions: {
      //   colors:['#00184D', '#40a474', '#FDDA0D', '#FF5733'],
      //   // labels: self.labels,
      // },
    };
  },
  computed: {
    chartOptions() {
      return {
        colors:['#40a474', '#00184D', '#FDDA0D', '#FF5733'],
        labels: this.labels,
        dataLabels: {
          // enabled: false,
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#FDDA0D',
            opacity: 0.9,
          },
          dropShadow: {
            enabled: false,
            // top: 1,
            // left: 1,
            // blur: 1,
            // color: '#000',
            // opacity: 0.45
          },
        },
      };
    },
    series() {
      return this.items.map((item) => item.value);
    },
    labels() {
      return this.items.map((item) => item.text);
    },
  },
};
</script>

<style lang="scss">
  // .grafico-dona .apexcharts-legend {
  //   display: none;
  // }
</style>